import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getSession } from '@/domains/auth/services/auth.service';

interface Props {
  allowedRoles?: string[];
}

export default function ProtectedRoute({ allowedRoles }: Props) {
  const location = useLocation();
  const session = getSession();

  // Non connecté → login
  if (!session) {
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  // Rôle insuffisant → dashboard par défaut
  if (allowedRoles && allowedRoles.length > 0) {
    const hasRole = allowedRoles.includes(session.roleCode);
    if (!hasRole) {
      return <Navigate to={session.dashboardPath} replace />;
    }
  }

  return <Outlet />;
}